// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g2Du","content":"styles_content__1hHTL"};